<template >
  <div class="ModalContent v-modal" v-if="html">
    <div class="overlay" @click.prevent="close"></div>
    <div class="wrapper">
      <div class="v-modal-content" v-html="html"></div>
      <div class="buttons text-center" v-if="buttons">
        <button
          v-for="(button, index) in buttons"
          :key="index"
          @click.prevent="callAction(button)"
          class="btn" :class="button.class??''"
        >
          <span v-html="button.label"></span>
        </button>
      </div>

      <button @click.prevent="close" class="close">
        <span class="fa fa-times"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalContent",
  components: {},
  props: {
    html: String,
    buttons: Array,
  },
  data: function () {
    return {
      current: 0,
    };
  },
  mounted: function () {},
  watch: {
    html(v){
      if(v){
        document.body.classList.add('show-v-modal')
      }else{
        document.body.classList.remove('show-v-modal')
      }
    }
  },

  computed: {},
  methods: {
    close() {
      this.$emit("close");
    },
    callAction(button) {
      if (typeof button.action != "function") {
        return;
      }
      button.action();
      this.close();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
